import focusElement from './focus-element';
import {delegate} from './events';

export default function init(excludeSelector = '.smooth-off') {
    document.addEventListener('click', delegate('a[href^="#"]', function () {
        if (this.matches(excludeSelector)) {
            return;
        }
        const id = this.href.substring(this.href.indexOf('#') + 1);
        if (!id) {
            return;
        }
        const target = document.getElementById(id);
        if (!target) {
            return;
        }
        focusElement.call(target, true);
    }));
}